import { Holiday } from 'domain/Holiday';
import { Map } from 'immutable';
import DomainObjectView from 'domain/DomainObjectView';
import { AppState } from '../types';

export const getHolidayById = (state: AppState, id: number): Holiday => {
  if (state.holidayList.isLoading) {
    throw Error('Holiday list is loading');
  }
  return state.holidayList.holidayMapById.get(id) as Holiday;
};

let oldHolidayMapById: Map<number, DomainObjectView<Holiday>> | null = null;
let holidayListForOldHolidayMapById: Holiday[] | null = null;

export const getHolidayList = (state: AppState): Holiday[] => {
  if (state.holidayList.isLoading) {
    return [];
  }
  if (oldHolidayMapById === state.holidayList.holidayMapById && holidayListForOldHolidayMapById !== null) {
    return holidayListForOldHolidayMapById;
  }
  const out = state.holidayList.holidayMapById.keySeq().map((id) => getHolidayById(state, id))
    .sortBy((holiday) => holiday.date).toList();

  oldHolidayMapById = state.holidayList.holidayMapById;
  holidayListForOldHolidayMapById = out.toArray();

  return holidayListForOldHolidayMapById;
};
